import {
  getArticleById,
  getArticleByLegacyUrl,
} from "../../services/articlesService";
import { normalizeArticle } from "./article.utils";

// Query definitions shared by the article page and its route loader, so both
// land on one cache entry.
export const isArticleId = (value) => /^\d+$/.test(value ?? "");

// Before the ID cutover (2026-09-30) links were /articles/<slug>. Emails, PDFs
// and QR codes still carry them, so those resolve the slug to an ID first.
export const isLegacyArticleLink = (articleId, slug) =>
  Boolean(articleId) && !isArticleId(articleId) && !slug;

export const articleQuery = (articleId) => ({
  queryKey: ["article", articleId],
  queryFn: async () => {
    const result = await getArticleById(articleId);
    if (!result) {
      return result;
    }
    return normalizeArticle(result);
  },
  retry: 1,
});

export const legacyArticleQuery = (legacySlug) => ({
  queryKey: ["legacy-article", legacySlug],
  queryFn: () => getArticleByLegacyUrl(legacySlug),
  retry: 1,
});

// The one request an article URL needs first: the article itself, or the
// legacy-slug lookup that redirects to it.
export const articleRouteQueries = ({ articleId, slug }) => {
  if (isArticleId(articleId)) {
    return [articleQuery(articleId)];
  }
  if (isLegacyArticleLink(articleId, slug)) {
    return [legacyArticleQuery(articleId)];
  }
  return [];
};
